import { useEffect, useState } from 'react'
import { IconMenu2, IconX } from '@tabler/icons-react'
import { Button } from '@/components/Button.tsx'
import GalleryNavigation from './GalleryNavigation.tsx'
import { FileSelectionType } from '@/hooks/useFileSelection.tsx'
import { Album } from '@/models/album.ts'
import { DriveContact, HeyDrive } from '@/models/drive.ts'

interface GalleryNavMobileProps {
  drive: HeyDrive
  albums: Album[]
  fileSelection: FileSelectionType
  onScrollToAlbum: (album: Album) => void
  contact: DriveContact | null
}

export function GalleryNavHamburgerButton({ onClick }: { onClick: () => void }) {
  return (
    <Button color='ghost' className='px-2' onClick={onClick}>
      <IconMenu2 size={24} />
    </Button>
  )
}

export function GalleryNavigationDrawer({
  drive,
  albums,
  fileSelection,
  onScrollToAlbum,
  contact,
}: GalleryNavMobileProps) {
  const [isOpen, setIsOpen] = useState(false)

  // Prevent body scroll when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  return (
    <>
      {/* Hamburger button */}
      <GalleryNavHamburgerButton onClick={() => setIsOpen(true)} />

      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-[60] bg-[black] transition-opacity duration-300 ${
          isOpen ? 'bg-opacity-60 pointer-events-auto' : 'bg-opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsOpen(false)}
      />

      {/* Drawer */}
      <div
        className={`fixed top-0 left-0 h-full w-72 z-[70] bg-neutral shadow-xl transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        {/* Drawer header */}
        <div className='flex items-center justify-between px-4 h-14 border-b border-base-300'>
          <span className='font-serif text-lg'>Navigation</span>
          <button className='opacity-60 hover:opacity-100 transition-opacity' onClick={() => setIsOpen(false)}>
            <IconX size={20} />
          </button>
        </div>

        {/* Navigation */}
        <div className='p-2 overflow-y-auto' style={{ maxHeight: 'calc(100vh - 3.5rem)' }}>
          <GalleryNavigation
            drive={drive}
            albums={albums}
            fileSelection={fileSelection}
            onScrollToAlbum={onScrollToAlbum}
            contact={contact}
            isExpanded={true}
            onClose={() => setIsOpen(false)}
          />
        </div>
      </div>
    </>
  )
}
